// extracted by mini-css-extract-plugin
module.exports = {"tagGroup":"TagList_tagGroup__3p85T","tagTitle":"TagList_tagTitle__b04dv","tags":"TagList_tags__lvx4t","tagsSmall":"TagList_tagsSmall__gnC3z","tag":"TagList_tag__RjXnZ"};